// Тонкая запись зеркала настроек в localStorage (см. shared/services/offlinePrefs).
// Вызывается из Navbar (имя), MenuProvider (меню) и DashboardShell (вид карточек)
// при онлайне — офлайн-страницы читают этот ключ и повторяют онлайн-поведение.

import {
  OFFLINE_PREFS_STORAGE_KEY,
  mergeOfflinePrefs,
  type OfflinePrefs,
} from '@shared/services/offlinePrefs';

export function writeOfflinePrefs(partial: Partial<OfflinePrefs>): void {
  if (typeof window === 'undefined') return;
  try {
    const existing = window.localStorage.getItem(OFFLINE_PREFS_STORAGE_KEY);
    window.localStorage.setItem(OFFLINE_PREFS_STORAGE_KEY, mergeOfflinePrefs(existing, partial));
  } catch {
    // localStorage недоступен (private mode) — некритично, офлайн покажет дефолты
  }
}
